import Cookies from 'js-cookie';
import parseDomain from 'parse-domain';

import {COOKIES, DEFAULT_TRACK_LOCATION, HOST_REDIRECT, PROTOCOL_PREFIX, REDIRECT_TLD} from './constants';

/**
 * Method that returns a new URL points to IE store with the current location and tracking params
 * @param {string} uri uri where redirection should be made
 * @param {string} location where the redirection has been shown, to add to tracking param
 * @param {boolean} keepSearch if search params should be kept or removed.
 * @param {Array} allowedSearchParams Array of valid query parameters to include in the new url. If null, all query params will be added
 * @param {string} trackFeatName name to include in the feat-src tracking parameter
 * @returns new URL points to IE store with the current location
 */
export const getRedirectURL = (uri, location, keepSearch, allowedSearchParams, trackFeatName) => {
  const {protocol, hostname, port, search = ''} = (typeof window !== 'undefined' && window.location) || {};
  const {subdomain, domain} = parseDomain(hostname) || {};

  const newHostName = domain
    ? `${subdomain ? `${subdomain}.` : ''}${domain}${REDIRECT_TLD}${port ? `:${port}` : ''}`
    : HOST_REDIRECT;

  const newUrl = new URL(`${protocol || PROTOCOL_PREFIX}//${newHostName}`);
  newUrl.pathname = uri || '';
  if (keepSearch) {
    const validSearch = getValidSearchParams(search, allowedSearchParams);
    newUrl.search = validSearch;
  }

  newUrl.searchParams.append('plat-src', 'web');
  newUrl.searchParams.append('feat-src', `cbt-${trackFeatName}-${location || DEFAULT_TRACK_LOCATION}`);

  generateAffiliateParameters(newUrl);
  generateConvertParameters(newUrl);

  return newUrl.toString();
};

/**
 * Method that returns search URL parameters removing those that are not included in allowedSearchParams
 * @param {string} search - search string containing a '?' followed by the parameters of the URL
 * @param {Array} allowedSearchParams Array of valid query parameters to include in the new url. If null, all query params will be added
 * @returns search string with the parameters of the URL.
 */
export const getValidSearchParams = (search, allowedSearchParams) => {
  const searchParams = new URLSearchParams(search);
  const keys = [...searchParams.keys()];
  if (allowedSearchParams) {
    keys.forEach((key) => {
      if (!allowedSearchParams.includes(key)) {
        searchParams.delete(key);
      }
    });
  }

  return searchParams.toString() === '' ? '' : `?${searchParams.toString()}`;
};

const generateAffiliateParameters = (url) => {
  if (url?.searchParams) {
    const affId = Cookies.get(COOKIES.AFF_ID);
    if (affId) {
      url.searchParams.append('affid', affId);
      const affAfl = Cookies.get(COOKIES.AFF_AFL);
      if (affAfl) {
        url.searchParams.append('afl', affAfl);
      }
      const affTduid = Cookies.get(COOKIES.AFF_TDUID);
      if (affTduid) {
        url.searchParams.append('tduid', affTduid);
      }
    }
  }
};

const generateConvertParameters = (url) => {
  if (url?.searchParams && typeof window !== 'undefined' && typeof window.convert !== 'undefined' && window.convert) {
    const convV = window.convert.getCookie(COOKIES.CONVERT_V);
    if (convV) {
      url.searchParams.append(COOKIES.CONVERT_V, convV);
    }
    const convS = window.convert.getCookie(COOKIES.CONVERT_S);
    if (convS) {
      url.searchParams.append(COOKIES.CONVERT_S, convS);
    }
  }
};
